import { Deserializable } from '../../deserializable';
import { KendoGridSort } from './kendo-grid-sort.model';

export class GridPageOptions implements Deserializable {
  public Take: number;
  public Skip: number;
  public Page: number;
  public PageSize: number;
  public Sort: Array<KendoGridSort>;

  constructor() {
    this.Sort = new Array<KendoGridSort>();
  }

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
